var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircles = function SvgCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.5,
    height: 27.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2d2e2d",
    strokeWidth: 1.5,
    "data-name": "Group 3243"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 7",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.75
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 8",
    transform: "translate(0 10.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.75
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 9",
    transform: "translate(12.5 10.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.75
  })))));
};
export { SvgCircles as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOS41IiBoZWlnaHQ9IjI3LjUiIHZpZXdCb3g9IjAgMCAyOS41IDI3LjUiPgogIDxnIGlkPSJHcm91cF8zMjQzIiBkYXRhLW5hbWU9Ikdyb3VwIDMyNDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTkgLTM3OC41KSI+CiAgIDxnIGlkPSJFbGxpcHNlXzciIGRhdGEtbmFtZT0iRWxsaXBzZSA3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDUgMzc4LjUpIiBmaWxsPSJub25lIiBzdHJva2U9IiMyZDJlMmQiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgPGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSI4LjUiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8Y2lyY2xlIGN4PSI4LjUiIGN5PSI4LjUiIHI9IjcuNzUiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJFbGxpcHNlXzgiIGRhdGEtbmFtZT0iRWxsaXBzZSA4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTkgMzg5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMmQyZTJkIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICAgIDxjaXJjbGUgY3g9IjguNSIgY3k9IjguNSIgcj0iOC41IiBzdHJva2U9Im5vbmUiLz4KICAgICAgPGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSI3Ljc1IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgICA8ZyBpZD0iRWxsaXBzZV85IiBkYXRhLW5hbWU9IkVsbGlwc2UgOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjExLjUgMzg5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMmQyZTJkIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICAgIDxjaXJjbGUgY3g9IjguNSIgY3k9IjguNSIgcj0iOC41IiBzdHJva2U9Im5vbmUiLz4KICAgICAgPGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSI3Ljc1IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";